import { GetterTree } from 'vuex';
import { AuthState } from './types';
import { StoreState } from '@/types';
import { isArray } from 'util';

const authGetters: GetterTree<AuthState, StoreState> = {
  state: (state) => state.state,
  authenticated: (state) => state.token ? true : false,
  permissions: (state) => {
    if (!state.token) { return {}; }
    const split = String(state.token).split('.');
    if (split.length < 3) { return {}; }

    const ob = JSON.parse(atob(split[1]));
    return ob.perms;
    // "perms": {
    //   "accounts": {
    //     "can_read": true,
    //     "can_write": true,
    //     "can_delete": true
    //   },
    //   "orderingadmin": {
    //     "can_read": true,
    //     "can_write": true,
    //     "can_delete": true
    //   }
    // }
  },
  permissionsFlat: (state, getters) => {
    const res: any = {};
    for (const key of Object.keys(getters.permissions)) {
      if (!getters.permissions.hasOwnProperty(key)) { continue; }
      const ob = getters.permissions[key];
      for (const perm of Object.keys(ob)) {
        const hasPerm = ob[perm];
        if (hasPerm) {
          res[key + '.' + perm] = true;
        }
      }
    }
    return res;
  },
  hasPermission: (state, getters) => ((perm: string[] | string) => {
    if (!isArray(perm)) {
      perm = [perm];
    }
    for (const p of perm) {
      if (!getters.permissionsFlat[p]) {
        return false;
      }
    }
    return true;
  }),
  account: (state) => {
    if (!state.token) { return {}; }
    const split = String(state.token).split('.');
    if (split.length < 3) { return {}; }

    const ob = JSON.parse(atob(split[1]));
    return ob;
  },

  initials: (state, getters) => {
    if (!getters.account) return '?';
    const prefix = getters.account.email.split('@') || '?';
    const split = (prefix[0] || '?').split(/ _\./);
    if (split.length > 1) {
      return split[0][0] + split[1][0];
    }
    return prefix[0][0];

    // state.account.first_name, //((state.account || {}).first_name || '?')[0] + ((state.account || {}).last_name || '?')[0],
  }
};

export default authGetters;
